import {ReleaseBundle} from './releasebundle';
import {ProjectBranch} from './branch';
import {Project} from './project';
import {PageResponse} from '../pageResponse';
import {PageRequest} from '../pageRequest';


export class ReleaseBundleHist {
    id?: string;
    releaseBundle?: ReleaseBundle;
    projectBranch?: ProjectBranch;
    project?: Project;
    creationDate?: string;
    creationUser?: string;
}

export class ReleaseBundleHistResponse extends PageResponse {
    content: ReleaseBundleHist[];
}

export class ReleaseBundleHistPageRequest extends PageRequest{
    branchId?: string;
    projectId?: string;
}
